(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').directive('mxBarChart', MxBarChartDirective);

	MxBarChartDirective.$inject = ['$injector', 'mx.SolutionBuilderAgent.BaseChartService'];

	function MxBarChartDirective($injector, baseChartService) {
		var directive = baseChartService.mxBaseChartDirective($injector);
		directive.bindToController.showOnlyTopBars = '@';

		directive.controller = MxBarChartCtrl;
		return directive;
	}

	MxBarChartCtrl.$inject = ['$injector', '$controller', '$scope', '$attrs', '$element', 'mx.SolutionBuilderAgent.BaseChartService'];
	function MxBarChartCtrl($injector, $controller, $scope, $attrs, $element, baseChartService) {
		var vm = $controller('mx.SolutionBuilderAgent.MxBaseChartController', {
			$injector: $injector,
			$scope: $scope,
			$attrs: $attrs,
			$element: $element,
		});

		var minHeightOfSeries = 30;

		vm.getChartConfig = function () {
			return baseChartService.getBaseChartConfig(vm).then(function (baseConfig) {
				var config = angular.extend({}, baseConfig);

				config.series.forEach((serie) => {
					angular.extend(serie, {
						type: 'bar',
						dataLabels: {
							enabled: Boolean(vm.labelsFormat),
							format: vm.labelsFormat || '',
						},
					});
				});

				if (vm.showOnlyTopBars === 'true') {
					var dataConfig = angular.copy(config.series[0].data);
					var numOfSeriesToShow = 0;

					config.responsive.rules.push({
						condition: {
							callback: function () {
								var newNumOfSeriesToShow = Math.floor(this.chartHeight / minHeightOfSeries);
								if (newNumOfSeriesToShow === numOfSeriesToShow) {
									return;
								}
								numOfSeriesToShow = newNumOfSeriesToShow;

								if (this.series[0].data.length !== numOfSeriesToShow) {
									this.series[0].setData(
										dataConfig.filter(function (data, index) {
											return index < numOfSeriesToShow;
										})
									);
								}
							},
						},
					});
				}

				return config;
			});
		};

		return vm;
	}
})();
